import { api } from './api';
import { RetentionProgram, RiderSubsidyConfig, AppConfig } from "../types/BusinessSettings";

// --- RETENTION PROGRAM ---
export const getRetentionProgram = () =>
    api.get<RetentionProgram[]>('/admin/retention-program');

export const updateRetentionProgram = (id: number, data: Partial<RetentionProgram>) =>
    api.patch<{ message: string; program: RetentionProgram }>(`/admin/retention-program/${id}`, data);

// --- RIDER SUBSIDY ---
export const getRiderSubsidyConfig = () =>
    api.get<RiderSubsidyConfig>('/admin/rider-subsidy-config');

export const updateRiderSubsidyConfig = (data: Partial<RiderSubsidyConfig>) =>
    api.patch<{ message: string; config: RiderSubsidyConfig }>('/admin/rider-subsidy-config', data);

// --- APP CONFIGS (Min Balances) ---
export const getAppConfigs = () =>
    api.get<AppConfig[]>('/admin/app-configs');

export const updateAppConfig = (id: number, data: Partial<AppConfig>) =>
    api.patch<{ message: string; config: AppConfig }>(`/admin/app-config/${id}`, data);